import { Tooltip, Typography, TypographyProps } from "@mui/material";
import { ConvertMprcColorsToString } from "components";
import * as React from "react";
import { useEffect, useRef, useState } from "react";

export type LmsCardVariants =
    | "caption"
    | "title"
    | "titleAlt"
    | "line"
    | "lineWrap"
    | "link"
    | "linkAlt"
    | "name"
    ;

interface IProps {
    variant: LmsCardVariants;
    component?: React.ElementType;
    color?: MprcColorsExtended | [MprcColors, MprcColorVariant];
    reverse?: boolean;
    tooltip?: string;
}

type Props = IProps & Omit<TypographyProps, "variant" | "color" | "bgcolor">;

export const MprcCardTypography: React.FC<Props> = (props) => {
    const { children, variant, component, color, reverse, tooltip, ...rest } = props;

    const [hoverStatus, setHover] = useState<boolean>(false);
    const textElementRef = useRef<any>(undefined);

    useEffect(() => {
        if (tooltip && textElementRef.current) {
            if (variant == "title" || variant == "titleAlt") {
                const diff = textElementRef.current.scrollHeight - textElementRef.current.clientHeight;
                setHover(diff > 2 && textElementRef.current.scrollHeight > textElementRef.current.clientHeight);
            } else if (variant == "name") {
                setHover(textElementRef.current.scrollWidth > textElementRef.current.clientWidth);
            }
        }
    }, []);

    //
    return (
        <Tooltip
            title={tooltip}
            disableHoverListener={!hoverStatus}
        >
            <Typography
                variant="inherit"
                component={component || "div"}
                {...rest}
                ref={textElementRef}
                sx={
                    (theme) => {
                        const c: { color?: string, backgroundColor?: string; } = {};

                        if (color != undefined) {
                            c.color = ConvertMprcColorsToString(theme, color);
                            if (reverse && color != "inherit" && color != "transparent") {
                                c.backgroundColor = c.color;
                                c.color = theme.palette.common.white;
                            }
                        }

                        return ({
                            ...theme.extended.lmsCard[variant],
                            ...c,
                        });
                    }
                }
            >
                {children}
            </Typography>
        </Tooltip>
    );
};
